<template>
	<div>
		<div v-if="isFirst">
			<div>
				<el-row :gutter="12">
					<el-col :span="4">
						<el-select v-model="type" style="width: 110px;" @change="updateTable">
							<el-option value="0" label="全部类型"></el-option>
<!--							<el-option value="1" label="激活码"></el-option>-->
<!--							<el-option value="2" label="配件"></el-option>-->
<!--							<el-option value="3" label="租赁商品"></el-option>-->
							<el-option value="4" label="租赁商品"></el-option>
							<el-option value="5" label="买断商品"></el-option>
                            <el-option value="6" label="共享商品"></el-option>
						</el-select>
					</el-col>
					<el-col :span="20" style="text-align:right;">
						<el-select style="width: 110px;" v-model="selectValue" placeholder="请选择">
							<el-option label="订单号" value="1"></el-option>
							<el-option label="收件人" value="2"></el-option>
							<el-option label="联系电话" value="3"></el-option>
							<el-option label="订单时间" value="4"></el-option>
              <el-option label="设备序列号" value="5"></el-option>
						</el-select>
						<el-input type="text" style="width: 235px;margin-left: 3px;" v-model="queryValue" placeholder="请输入" v-if="isInput"></el-input>
						<el-date-picker
							style="width: 235px;margin-left: 3px;"
							v-model="time"
							v-if="!isInput"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							format="yyyy-MM-dd">
						</el-date-picker>
						<el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="updateTable">搜索</el-button>
					</el-col>
				</el-row>
			</div>
			<div style="margin-top: 20px;">
				<el-table ref="multipleTable"
					 :data="tableData"
					 style="width: 100%"
					 element-loading-text="数据正在加载中"
					 @selection-change="handleSelectionChange"
					 :header-cell-style="headClass"
					  :row-style="rowClass">
			      <el-table-column type="selection" width="60"></el-table-column>
			      <el-table-column prop="merchInfoRO.merchName" label="商品名" sortable></el-table-column>
			      <el-table-column label="类型">
			      	<template  slot-scope="scope">
			      		<span v-if="scope.row.merchInfoRO.merchType == 4">租赁商品</span>
					    <span v-if="scope.row.merchInfoRO.merchType == 5">买断商品</span>
                        <span v-if="scope.row.merchInfoRO.merchType == 6">共享商品</span>
			      	</template>
			      </el-table-column>
			      <el-table-column prop="merchInfoRO.quanlity" label="数量" width="60"></el-table-column>
			      <el-table-column label="总价" width="60">
                      <template slot-scope="scope">
				      		<div>
                                <span>{{moneyFormat(scope.row.amount)}}</span>
				      		</div>
				      	</template>
                  </el-table-column>
			      <el-table-column label="收件人">
			      	<template slot-scope="scope">
			      		<div>
			      			<div v-if="scope.row.deliveryInfo != null">
			      				<el-tooltip placement="right">
								  <div slot="content">联系电话:{{scope.row.deliveryInfo.tel}}<br/><br/>收件地址:{{scope.row.deliveryInfo.address}}</div>
								  <span>{{scope.row.deliveryInfo.receiver}}</span>
								</el-tooltip>
			      			</div>
			      			<div v-else>
			      				<span>-</span>
			      			</div>
			      		</div>
			      	</template>
			      </el-table-column>
			      <el-table-column prop="posttime" label="下单时间" :formatter="dateFormat"></el-table-column>
			      <el-table-column prop="payInfoRO.paytime" label="付款时间" :formatter="dateFormat"></el-table-column>
			      <el-table-column label="订单状态">
			      	<template slot-scope="scope">
			      		<div>
			      			<span v-if="scope.row.status == 101">已创建</span>
			      			<span v-if="scope.row.status == 102">已取消</span>
			      			<span v-if="scope.row.status == 103">失败</span>
			      			<span v-if="scope.row.status == 104">异常</span>
			      			<span v-if="scope.row.status == 105">未付款</span>
			      			<span v-if="scope.row.status == 106">已支付</span>
			      			<span v-if="scope.row.status == 107">已发货</span>
			      			<span v-if="scope.row.status == 108">已收货</span>
			      			<span v-if="scope.row.status == 109">已签收</span>
			      		</div>
			      	</template>
			      </el-table-column>
			      <el-table-column prop="orderId" label="订单号"></el-table-column>
			      <el-table-column label="操作">
			      	<template slot-scope="scope">
			      		<div>
			      			<!--<div v-if="scope.row.deliveryInfo != null && scope.row.status == 105">
			      				<button @click="delivery(scope.row)">发货</button>
			      			</div>
			      			<div v-else>
			      				<button @click="getMessage(scope.row)">查看</button>
			      			</div>-->
			      			<button @click="getMessage(scope.row)">查看</button>
			      			<button @click="renewal(scope.row)" v-if="isAgent && (scope.row.status == 101 || scope.row.status == 103 || scope.row.status == 105)">重新付款</button>
			      		</div>
			      	</template>
			      </el-table-column>
			    </el-table>
			    <el-pagination background
			    				style="text-align:right;margin-top: 15px;margin-bottom: 65px;"
			            @size-change="handleSizeChange"
			            @current-change="handleCurrentChange"
			            :current-page="currentPage"
			            :page-sizes="[10, 50, 100, 200]"
			            :page-size="pageSize"
			            layout="total, sizes, prev, pager, next, jumper"
			            :total="total">
			    </el-pagination>
			</div>
		</div>
		<div v-if="!isFirst">
			<div>
				<i class="el-icon-back" style="font-size: 16px;cursor:pointer;" @click="goback">订单发货</i>
			</div>
			<div style="margin-top: 20px;">
				<div>
					<el-row :gutter="12">
						<el-col :span="8">
							<div>
								<span style="font-size: 24px;">收货人:{{receiver}}</span>
							</div>
							<div>
								<table style="margin-top: 5px;font-size: 12px;">
									<tr>
										<td>
											<span>地址:</span>
										</td>
										<td>
											<span style="padding-left: 5px;">{{address}}</span>
										</td>
									</tr>
									<tr>
										<td>
											<span>联系电话:</span>
										</td>
										<td>
											<span style="padding-left: 5px;">{{tel}}</span>
										</td>
									</tr>
									<tr>
										<td>
											<span>订单时间:</span>
										</td>
										<td>
											<span style="padding-left: 5px;">{{posttime}}</span>
										</td>
									</tr>
								</table>
							</div>
						</el-col>
						<el-col :span="15">
							<div style="text-align: right;">
								<div>
									<el-select v-model="express" placeholder="请选择快递公司">
										<el-option value="1" label="顺丰"></el-option>
										<el-option value="2" label="申通"></el-option>
									</el-select>
								</div>
								<div>
									<el-input v-model="expressNum" style="width: 217px;margin-top: 10px;" placeholder="请填写快递单号"></el-input>
								</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
			<div style="margin-top: 15px;">
				<el-table
					:data="dataTable"
					style="width: 100%"
					:header-cell-style="headClass"
					:row-style="rowClass">
					<el-table-column prop="name" label="商品名"></el-table-column>
					<el-table-column prop="remark" label="产品描述"></el-table-column>
					<el-table-column prop="buyer" label="下单人"></el-table-column>
					<el-table-column prop="uprice" label="单价"></el-table-column>
					<el-table-column prop="quanlity" label="数量"></el-table-column>
					<el-table-column prop="amount" label="总计"></el-table-column>
				</el-table>
			</div>
			<div style="margin-top: 30px;text-align: right;">
				<div>
					<el-input v-model="sn" placeholder="请填写设备序列号" style="width: 217px;"></el-input>
				</div>
				<div style="margin-top: 10px;">
					<el-input v-model="remark" placeholder="请填写发货备注" style="width: 217px;"></el-input>
				</div>
				<div style="margin-top: 10px;">
					<el-button @click="sendCommodity">确认发货</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'orderCenter',
  components: {
  },
  data() {
    return {
    	total: 0,
      	currentPage: 1,
　　  	pageSize: 10,
		multipleSelection: [],
		tableData:[],
		type:"0",
		queryValue:'',
		selectValue:'',
		isFirst:true,
		isAgent:false,
		time:[],
		receiver:"",
		tel:"",
		address:"",
		posttime:"",
		express:'',
		expressNum:"",
		remark:"",
		orderId:"",
		sn:"",
		type:"",
		dataTable:[]
    }
  },
  watch: {
  },
  computed:{
  	isInput:function(){
  		if(this.selectValue != "4"){
  			this.queryValue = "";
  			return true;
  		}else{
  			return false;
  		}
  	}
  },
  mounted() {
  	this.initPage();
  },
  beforeDestroy() {
  },
  methods: {
  	initPage(){
  		var thiz = this;
  		axios.get(this.$store.getters.getApiValue+'/srsUser/getMyData.do').then(function (response) {
			var data = response.data;
			if(data.status == "200"){
				if(data.data.role == "2" || data.data.role == "3"){
					thiz.isAgent = true;
				}
				thiz.updateTable();
			}else{
			    thiz.$message.error(data.message);
			}
		}).catch(function (error) {
			console.log(error);
			thiz.$message.error("系统异常,请与管理员联系!");
		});
  	},
  	delivery(row){
  		this.receiver = row.deliveryInfo.receiver;
  		this.tel = row.deliveryInfo.tel;
  		this.address = row.deliveryInfo.address;
  		this.posttime = this.getFullStandardDate(row.posttime);
  		this.orderId = row.orderId;
  		this.type = row.merchInfoRO.merchType;
  		this.dataTable = [];
  		var item = {
  			quanlity:row.merchInfoRO.quanlity,
  			uprice:row.merchInfoRO.uprice,
  			amount:row.amount
  		}
  		if(row.merchInfoRO.name != null){
  			item.name = row.merchInfoRO.name;
  		}
  		if(row.merchInfoRO.remark != null){
  			item.remark = row.merchInfoRO.remark;
  		}
  		if(row.merchInfoRO.buyer != null){
  			item.buyer = row.merchInfoRO.buyer;
  		}
  		this.dataTable.push(item)
  		this.isFirst = false;
  	},
  	handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  	handleSizeChange(val) {
      this.pageSize = val;
      this.updateTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateTable();
    },
    headClass({ row, rowIndex}) {
    	if(rowIndex == 0){
    		return ''
    	}
	    return ''
	},
    rowClass({ row, rowIndex}) {
	    if(rowIndex%2 == 0){
	    	return 'background:#F1F2F7;'
	    }else{
	    	return 'background:white;'
	    }
	    return ''
	},
	dateFormat(row,column,cellValue,index){
		var str = cellValue;
		if(str == null || str == ""){
			return "";
		}else{
			return this.getFullStandardDate(str);
		}
	},
    updateTable(){
    	var thiz = this;
    	var param = {
  				pageId:this.currentPage,
  				size:this.pageSize,
  				type:this.type
  			}
  		if(this.selectValue == "1" && this.queryValue != ""){
  			param.orderId = this.queryValue;
  		}else if(this.selectValue == "2" && this.queryValue != ""){
  			param.receiver = this.queryValue;
  		}else if(this.selectValue == "3" && this.queryValue != ""){
  			param.tel = this.queryValue;
  		}else if(this.selectValue == "4"){
  			if(this.time != null && this.time.length > 0){
	  			param.startDate = this.getStandardDate(this.time[0]);
	  			param.endDate = this.getStandardDate(this.time[1]);
	  		}
  		}else if(this.selectValue == "5"){
       param.sn = this.queryValue;
      }

  		const loading = this.$loading({
          lock: true,
          text: '获取表格数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
    	axios.get(this.$store.getters.getApiValue+'/order/searche.do',{
  			params:param
  		}).then(function (response) {
  			loading.close();
		    var data = response.data;
		    if(data.status == "200"){
		    	thiz.total = data.totalCount;
		    	thiz.tableData = data.data;
		    }else{
		    	thiz.$message.error("查询异常");
		    }
		  }).catch(function (error) {
		  	loading.close();
		    console.log(error);
		    thiz.$message.error("系统异常，请与管理员联系!");
		  });
    },
    goback(){
    	this.isFirst = true;
    },
    getStandardDate(val){
    	var year = val.getFullYear();
        var month = val.getMonth() + 1;
        var day = val.getDate();
        month = month < 10 ? "0"+month : month;
        day = day < 10 ? "0"+day : day;
        return year+"-"+month+"-"+day;
    },
    getFullStandardDate(str){
    	var val = new Date(str)
    	var year = val.getFullYear();
        var month = val.getMonth() + 1;
        var day = val.getDate();
        var hour = val.getHours();
        var minute = val.getMinutes();
        var second = val.getSeconds();
        month = month < 10 ? "0"+month : month;
        day = day < 10 ? "0"+day : day;
        hour = hour < 10 ? "0"+hour : hour;
        minute = minute < 10 ? "0"+minute : minute;
        second = second < 10 ? "0"+second : second;
        return year+"-"+month+"-"+day+" "+hour+":"+minute+":"+second;
    },
    sendCommodity(){
    	var params = {
    		express:this.express,
    		expressNum:this.expressNum,
    		orderId:this.orderId,
    		remark:this.remark,
    		sn:this.sn,
    		type:this.type
    	}
    	axios.get(this.$store.getters.getApiValue+'/order/delivery.do',{
  			params:params
  		}).then(function (response) {
		    var data = response.data;
		    if(data.status == "200"){
		    	this.$mwssage.success("发货!");
		    }
		  }).catch(function (error) {
		    console.log(error);
		  });
    },
    getMessage(row){
    	alert(row.merchInfoRO.merchName);
    },
    renewal(row){
    	var thiz = this;
   		this.$confirm('确认重新支付'+row.orderId+'订单吗?')
  			.then(_ => {
  				const loading = this.$loading({
		          lock: true,
		          text: '重新支付中...',
		          spinner: 'el-icon-loading',
		          background: 'rgba(0, 0, 0, 0.7)'
		        });
	        	axios.get(thiz.$store.getters.getApiValue+'/order/pay.do',{
					params:{
					  	orderId:row.orderId
					}
				}).then(function (response) {
					var data = response.data;
					if(data.status == "200"){
						if(data.data){
							thiz.$message.success('重新支付成功!数据有延迟，请在1分钟后刷新页面进行查看订单信息!');
							setTimeout(() => {
								loading.close();
								thiz.updateTable();
					        }, 5000);
						}else{
							thiz.$message.error('重新支付失败!');
							loading.close();
						}
					}else{
						loading.close();
						thiz.$message.error(data.message);
					}
				}).catch(function (error) {
					console.log(error);
					loading.close();
					thiz.$message.error("系统异常!请与管理员联系!");
				});
			}).catch(_ => {});
    },
    moneyFormat(val){
        val = val.toString().replace(/[^\d.]/g,""); //清除"数字"和"."以外的字符
        let val1 = parseFloat(val).toFixed(2);  //保留两位小数
        let val2 = val1.toString();
        let arr = val2.split('.');
        let arr1 = arr[0].split('');
        let str3 = "";
        let arr2 = [];
        for(let i=arr1.length-1,j=0;i>=0;i--,j++) {
          str3 = '' + arr1[i] + str3;
          if(j%3==2) {
            arr2.unshift(str3)
            str3 = "";
          }else if(i==0) {
            arr2.unshift(str3)
          }
        }
        let str4 = arr2.join(',');
        let str5 = str4 + '.' + arr[1];
        return str5;
    }
  }
}
</script>

<style>
	.el-table{
	  	font-size: 12px;
	  	border-bottom: 1px solid #dcd8d8;
	  	color: black;
	}
	.el-table tr th{
	    border-top: 0px;
	  	border-left: 0px;
	  	border-right: 0px;
	}
	.el-table tr td{
	  	border-bottom: 1px solid #dcd8d8;
 	}
</style>
